module.exports = __webpack_public_path__ + "flyer_image_overlay_fun_icons_007-159203118c00e2209dfe6ab4a52f3e76.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Layouts/Flourishes/flyer_image_overlay_fun_icons_007.png
// module id = 1564
// module chunks = 1